import numeral from 'numeral';
import moment from 'moment';

export class FormatterUtils {
  static formatNumber(value): string {
    if (typeof value === 'undefined' || value === null || isNaN(value)) {
      return '';
    }
    if (typeof value !== 'number') {
      value = Number(value);
    }

    let text = numeral(value).format('[0][,]0[.][00]');
    return text;
  }

  static formatDate(value): string {
    if (!value) {
      return null as any;
    }
    const aux = moment(value).format('DD/MM/YYYY');
    return aux;
  }
}
